import { useMultiStepModal } from '@frontend/payments-multistep-modal';

export enum RegisterTerminalModalStripeSteps {
  InstallBattery = 'install-battery',
  PlugInTerminal = 'plug-in-terminal',
  TurnTerminalOn = 'turn-terminal-on',
  ConnectToNetwork = 'connect-to-network',
  GeneratePairingCode = 'generate-pairing-code',
  PairYourTerminal = 'pair-your-terminal',
}

export enum RegisterTerminalModalJustifiSteps {
  PreCheck = 'pre-check',
  TurnOnTerminal = 'turn-on-terminal',
  ConnectToWifiStep1 = 'connect-to-wifi-1',
  ConnectToWifiStep2 = 'connect-to-wifi-2',
  ConnectToWifiStep3 = 'connect-to-wifi-3',
  IncorrectPassword = 'incorrect-password',
  GenrateDeviceId = 'genrate-device-id',
}

export const useRegisterTerminalModal = () => {
  const { activeStep, goToStep: goToStepInContext } = useMultiStepModal();
  const goToStep = (step: RegisterTerminalModalStripeSteps | RegisterTerminalModalJustifiSteps) =>
    goToStepInContext?.(step);

  return { activeStep, goToStep };
};
